import React from 'react';
import { connect } from "react-redux";
import { fetchSongs, selectSong } from "../actions";
import { Button, Card, Image } from 'semantic-ui-react'
import ReactJkMusicPlayer from 'react-jinke-music-player'
import 'react-jinke-music-player/assets/index.css'

class SongList extends React.Component{    

    componentDidMount = () => {
        console.log("hi: ", this.props.songs.filter((song)=> song ));
        console.log(this.props.fetchSongs());
    }

    renderList() {
        return this.props.songs.map((song ) => {
            console.log(song);
            return (
                <Card key={song.key}>
                    <Card.Content>
                        <Image
                        floated='right'
                        size='mini'
                        src={song.images.coverart}
                        />
                        <Card.Header>{song.title}</Card.Header>
                        <Card.Meta>{song.subtitle}</Card.Meta>
                        <Card.Description>
                            {song.share.subject}
                        </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                        <div className='ui two buttons'>
                        <Button basic color='green' onClick={()=> this.props.selectSong(song)}>
                            Info
                        </Button>
                        {/* <Button basic color='red'>
                            Play
                        </Button> */}
                        </div>
                    </Card.Content>
                </Card>
            )
        })
    }

    render() {
        return (
            <div className="ui divided list">
                <Card.Group>
                    {this.renderList()}
                </Card.Group>
                <ReactJkMusicPlayer 
                    autoPlay={false} 
                    audioLists={this.props.selectedSong && [
                        { 
                            musicSrc: this.props.selectedSong.hub.actions[1].uri,
                            singer: this.props.selectedSong.subtitle,
                            name: this.props.selectedSong.title,                         
                        }
                    ]} />

            </div>
        )
    }
}

const mapStateToProps = (state) => {    
    return { 
        songs: state.songs,
        selectedSong: state.selectedSongs
    };
}

export default connect(mapStateToProps, {selectSong, fetchSongs})(SongList);